import { style } from '@vanilla-extract/css';

export const outerContainer = style({
  width: '100%',
  padding: '1.5rem 2rem',
  backgroundColor: 'var(--wt-footer-background-color)',
  color: 'var(--wt-footer-text-color)',

  // TODO: different viewports screensizes
});

export const innerContainer = style({
  marginLeft: 'auto',
  marginRight: 'auto',
  width: '100%',
  maxWidth: '72rem',
  // TODO: different viewports screensizes
});

export const publicationRow = style({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  rowGap: '1.5rem',
});

export const copywritingRow = style({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  alignItems: 'center',
  rowGap: '1.5rem',

  '@media': {
    'screen and (min-width: 640px)': {
      flexDirection: 'row',
    },
  },
});

export const copywritingText = style({
  fontWeight: 300,
  fontSize: '0.75rem',
  lineHeight: '1rem',
});
